// Libraries
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

// Redux
import { connect } from 'react-redux';
import { removeUserFromTeam } from '~/redux/actions/team-actions';

/**********
 ** Component: DeleteButton
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
class DeleteButton extends PureComponent {
	constructor(props) {
		super(props);

		this.handleClickOnRemoveButton = this.handleClickOnRemoveButton.bind(this);
	}

	handleClickOnRemoveButton = userId => {
		// console.log('userId', userId);
		this.props.dispatch(removeUserFromTeam(userId));
	};

	render() {
		const { userId, label } = this.props;
		return (
			<Button
				type="button"
				ariaLabel={`${label} user with the id ${userId}`}
				onClick={() => this.handleClickOnRemoveButton(userId)}
			>
				{label}
			</Button>
		);
	}
}

const Button = styled.button`
	margin: 0 auto;
	width: ${rem('108px')};
	height: ${rem('32px')};
	border-radius: ${rem('32px')} !important;
	line-height: ${rem('32px')};
	padding-left: ${rem('12px')};
	padding-right: ${rem('12px')};
	background-color: ${props => props.theme.cta};
	color: ${props => props.theme.white};
	text-align: center;
	border: 0;
	font-size: ${rem('12px')};
	font-weight: bold;
	cursor: pointer;
	transform: scale(1);
	transition: all 200ms ease-in-out;
	text-overflow: ellipsis;

	&:hover,
	&:focus {
		transform: scale(1.2);
	}

	&:active {
		transform: scale(0.98);
		background-color: hsl(12, 94%, 40%);
	}
`;

DeleteButton.propTypes = {
	userId: PropTypes.number,
	label: PropTypes.string,
};

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(DeleteButton);



// WEBPACK FOOTER //
// ./src/pages/profile/my-team/my-team-remove-user.jsx